import { combineReducers } from "@reduxjs/toolkit";
import sidebarSlice from "./slices/sidebarSlice";
import oldDataSlice from "./slices/oldDataSlice"; // Remember, don’t use curly brackets
import scheduleSlice from "./slices/scheduleSlice"; // Remember, don’t use curly brackets
import filterValueSlice from "./slices/filterValueSlice"; // Remember, don’t use curly brackets
import dashboardLayoutSlice from "./slices/dashboardLayoutSlice";

const rootReducer = combineReducers({
  sidebar: sidebarSlice,
  oldData: oldDataSlice,
  schedule: scheduleSlice,
  filterValue: filterValueSlice,
  dashboardLayout: dashboardLayoutSlice,
});

export default rootReducer;
